<template>
    <div class="animated fadeIn">
        <b-row class="justify-content-center mt-5">
            <b-col xl="6" lg="8">
                <b-card>
                    <div slot="header">
                        Set Periode Transaski Distribusi/Sirkulasi Koran
                    </div>
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label-cols="5"  label="Current Periode" >
                                    <b-form-input v-model="model.tglkoran" type="date" disabled></b-form-input>                                        
                                </b-form-group>                                
                            </b-col>
                            <b-col cols="6">    
                                {{model.tglkoran | ambilNamaHari }}, {{model.tglkoran | moment('DD-MMM-YYYY') }}
                            </b-col>
                        </b-row>                      
                        <b-row>
                            <b-col cols="6">
                                <b-form-group label-cols="5"  label="Set Next Periode To" >
                                    <b-form-input v-model="model.tglnext" type="date" ></b-form-input>                                        
                                </b-form-group>                                
                            </b-col>
                            <b-col cols="6">    
                                {{model.tglnext | ambilNamaHari }}, {{model.tglnext | moment('DD-MMM-YYYY') }}
                            </b-col>
                        </b-row>                      
                        <p class="m-0 text-danger">Transaski Distribusi/Sirkulasi Koran dibawah tanggal <strong>Next Periode</strong> yg sudah Closed akan terkunci, tidak bisa ditambah,diubah dan dihapus</p>
                        <b-row class="justify-content-center mt-2">
                            <button  class="btn btn-primary mr-1" @click="setPeriode()"><i class="fa fa-save"></i> Set Current Periode</button>
                            <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close </button>
                        </b-row>
                </b-card>
            </b-col>
        </b-row>
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>

<style lang="scss">
      .input-group {
          .input-group-prepend {
              label {
                  width: 130px !important;
                  margin-right:5px;
              }
          }
      }
</style>
<script>
import VueMonthlyPicker from 'vue-monthly-picker';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import dropdown from "../../data/dropdown";
import periode from "../../apis/koran_periode";
toastr.init();

export default {
  components: {VueMonthlyPicker,Loading},
  data() {
    return {
      horizontal: true,
      isLoading:false,
      model:{tglnext:'', periodnext:'-'},
      monthLabels:dropdown.monthLabels
    };
  },    
  created: async function (){
     const curPeriode = await periode.get();
     var tglkoran=moment(curPeriode.tglkoran,'YYYY-MM-DD');
     var tglnext=moment(curPeriode.tglkoran,'YYYY-MM-DD').add(1,'days');
     this.model.tglkoran=tglkoran.format('YYYY-MM-DD');
     this.model.tglnext=tglnext.format('YYYY-MM-DD');
     this.model.tglaktif=moment(curPeriode.tglaktif,'YYYY-MM-DD');
     this.model.akhiraktif=moment(curPeriode.tglaktif,'YYYY-MM-DD').endOf('month');
    this.$watch('model.tglnext', function(newVal) {
        setTimeout(() => {
            if (moment(newVal)<this.model.tglaktif) {
                toastr.error('The date less than Accounting periode, NOT ALLOWED BY SYSTEM','ERROR MESSAGE',10000);
                this.model.tglnext=this.model.tglaktif.format('YYYY-MM-DD');
                this.$forceUpdate();
            }
            if (moment(newVal)>this.model.akhiraktif) {
                toastr.error('The date More than end of Month accounting  periode, NOT ALLOWED BY SYSTEM','ERROR MESSAGE',10000);
                this.model.tglnext=this.model.akhiraktif.format('YYYY-MM-DD');
                this.$forceUpdate();
            }
        }, 100);
    });       
  },  
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },  
  methods: {
    async setPeriode(){
        try {
            if (this.model.tglnext) {
                if (moment(this.model.tglnext)<this.model.tglaktif) {
                    toastr.error('The date less than Accounting periode, NOT ALLOWED BY SYSTEM','ERROR MESSAGE',10000);
                    this.model.tglnext=this.model.tglaktif.format('YYYY-MM-DD');
                    this.$forceUpdate();
                    return;
                }
                if (moment(this.model.tglnext)>this.model.akhiraktif) {
                    toastr.error('The date More than end of Month accounting  periode, NOT ALLOWED BY SYSTEM','ERROR MESSAGE',10000);
                    this.model.tglnext=this.model.akhiraktif.format('YYYY-MM-DD');
                    this.$forceUpdate();
                    return;
                }                
                this.isLoading=true;
                this.model.tglnext=moment(this.model.tglnext).format('YYYY-MM-DD');
                console.log('this.model.tglnext : ',this.model.tglnext);

                let user = await periode.set(this.model);
                this.isLoading=false;    
                toastr.success("Complete successfully", "Closing Periode");
                // console.log(user);
                this.$store.commit("user",user);
                var tglkoran=moment(user.tglkoran,'YYYY-MM-DD');
                var tglnext=moment(user.tglkoran,'YYYY-MM-DD').add(1,'M');
                this.model.tglkoran=tglkoran.format('YYYY-MM-DD');
                this.model.tglnext=tglnext.format('YYYY-MM-DD');

                toastr.info("Current Periode has been Change ");
            }
        } catch (error) {
            this.isLoading=false;
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    }, 
    close(){
      router.push("home");
    }, 
  }
};
</script>